import React from 'react';
import { StartButton } from '../styles/CaseStudyHome.styles';
import { Link } from 'react-router-dom';

const TaskDescription = ({ teamId }) => {
    return (
        <div>
            <h2>Task Description</h2>

            <h3>The Task</h3>
            <p>
                Your team will use a series of funding provided by the Cuban e-Bike Private/Public partnership to design, price, and advertise your bike. You will be given specific funding for the initial development and then a discretionary fund to support advertising or R&D. The initial grant will last for 18 months, divided into 3 distinct periods. The team with the highest total profit at the end of the 18 months will be declared the victor and will receive further funding and assorted accolades.
            </p>

            <h3>Period 1</h3>
            <ul>
                <li><strong>Launch</strong> – Initial decisions made on bike design, R&D, advertising, and pricing.</li>
                <li>A budget of 25 manufacturing credits is provided for initial design, $1.5 million for discretionary R&D spending, and $500k for advertising. This money cannot be saved for use in future periods.</li>
                <li>In-market competition versus the other teams.</li>
            </ul>

            <h3>Period 2</h3>
            <ul>
                <li><strong>Review and Adjust</strong> – Review results from Period 1 and make new decisions on R&D, advertising, and pricing.</li>
                <li>A budget of $1.5 million in discretionary R&D spending and $500k in advertising is provided. This money cannot be saved for use in future periods.</li>
                <li>In-market competition versus the other teams.</li>
            </ul>

            <h3>Period 3</h3>
            <ul>
                <li><strong>Final Adjustments</strong> – Review results from Period 2 and make final decisions on R&D, advertising, and pricing.</li>
                <li>A budget of $2 million is allocated for discretionary spending across advertising and/or R&D.</li>
                <li>In-market competition versus the other teams.</li>
            </ul>

            <h3>Final Results</h3>
            <p>
                The final results will be shared, and the winning team will be praised for their strategic choices. The team with the highest total profit at the end of the 18 months will receive additional funding and accolades.
            </p>

            <h3>The Best E-Bike in Cuba</h3>
            <p>
                Everyone is looking forward to your success. What you accomplish will not only help bring “Iniciativa Verde” to life but can serve as a model for helping other countries leap forward in progress, leveraging this unique partnership model. The world is counting on you. Good luck!
            </p>

            <Link to={`/${teamId}/decision-tool`}>
                <StartButton>Start Game</StartButton>
            </Link>
        </div>
    );
};

export default TaskDescription;
